<h1 mat-dialog-title>Das neue PHOENIX Apothekenportal einfach erklärt</h1>
<div mat-dialog-content>
  <iframe src="https://player.vimeo.com/video/365725973" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
</div>
<div mat-dialog-actions>
  <button class="btn-primary" mat-button [mat-dialog-close]="true" cdkFocusInitial>Schließen</button>
</div>